import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RoutePath, StakingTab, generateRoutePath } from '../../app/router/config';
import NoCtaWallet from '../../components/common/no-cta-wallet';
import Header from '../../components/staking/header';
import Information from '../../components/staking/information';
import MyStakings from '../../components/staking/my-stakings';
import Overview from '../../components/staking/overview';
import { UserContext } from '../../context/user';
import Layout from '../../layout';
export default function Staking() {
    var t = useI18n().t;
    var user = useContext(UserContext).user;
    var tab = useParams().tab;
    var navigate = useNavigate();
    if (user === null && tab !== StakingTab.INFORMATION) {
        navigate(generateRoutePath(RoutePath.ROOT, {}), { replace: true });
    }
    return (_jsx(Layout, { children: _jsxs(_Fragment, { children: [_jsx(Header, { tab: tab, title: t('staking.page-title') }), !(user === null || user === void 0 ? void 0 : user.mpcWalletAddress) && tab !== StakingTab.INFORMATION ? (_jsx(NoCtaWallet, {})) : (_jsxs(_Fragment, { children: [tab === StakingTab.OVERVIEW && _jsx(Overview, {}), tab === StakingTab.MY_STAKINGS && _jsx(MyStakings, {}), tab === StakingTab.INFORMATION && _jsx(Information, {})] }))] }) }));
}
